import React, { useEffect } from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

import PrivateRoutes from './Privateroutes';

import PageAutenticacao from '../layouts/Autenticacao';
import LoginIntegracao from '../pages/LoginIntegracao';
import PageUsuario from '../pages/Usuario'; 
import Log from '../pages/Log2';
import Configuracoes from '../pages/Configuracoes';
import PerfilUsuario from '../pages/PerfilUsuario';
import CompartilhadoDownload from '../pages/CompartilhadoDownload';
import Dashboard from '../pages/Dashboard';
import RelatorioAnaliseAcessos from '../pages/Dashboard/Relatorio';
import { marcarSessao } from '../services/api';
import { trackPromise } from 'react-promise-tracker';
import services from '../services';
import PageHome from '../pages/Home';
import PageGaleriaMidia from '../pages/GeleriaMidia';
import LoginIntegracaoUrl from '../pages/LoginIntegracaoUrl';
import Login from "../../src/pages/Login"
import EsqueciMinhaSenha from '../pages/Login/esqueci-minha-senha';
import Cadastro from '../pages/Login/cadastro';
import AlterarSenha from '../pages/Login/alterar-senha';
import Participante from '../pages/Usuario';
import UsuarioNovoEditar from '../pages/Usuario/usuarioNovoEditar';
import Admin from '../pages/Admin';
import AdminNovoEditar from '../pages/Admin/adminNovoEditar';
import Cadastros from '../pages/Cadastros';
import ConcessionariaNovoEditar from '../pages/Cadastros/ConcessionariaNovoEditar';
import GrupoDealerNovoEditar from '../pages/Cadastros/GrupoDealerNovoEditar';

export default function Routes() {
  useEffect(() => {
    const callApi = () => {
      const isAuthenticated = services.storage.get('isAuthenticated');
      const hasToken = sessionStorage.getItem('authSistema');
      
      if (isAuthenticated && hasToken) {
        trackPromise(
          marcarSessao()
            .then((res) => {})
            .catch((error) => {
              console.error(error);
            })
        );
      }
    };

    let apiCallInterval = setInterval(callApi, 60000);

    // Limpa os event listeners e intervalo ao desmontar o componente
    return () => {
      clearInterval(apiCallInterval);
    };
  }, []);

  return (
    <BrowserRouter>
      <Switch>
        <Route path="/" exact component={Login} /> 
        <Route path="/esqueci-minha-senha" exact component={EsqueciMinhaSenha} />
        <Route path="/cadastro" exact component={Cadastro} />
        <Route path="/alterar-senha" exact component={AlterarSenha} />
        <Route path="/login-integracao" exact component={LoginIntegracao} />
        <Route path="/login/integracao/token" exact component={LoginIntegracaoUrl} />
        <PrivateRoutes path="/home" exact component={PageUsuario} />
        <PrivateRoutes path="/usuario" exact component={Participante} />
        <PrivateRoutes path="/usuario/novo/perfil" exact component={UsuarioNovoEditar} />
        <PrivateRoutes path="/usuario/editar/perfil/:id" exact component={UsuarioNovoEditar} />
        {/* RD 95133: menu "Cadastros" com as abas Usuários, Concessionárias e Grupos Dealer */}
        <PrivateRoutes path="/cadastros" exact component={Cadastros} />
        <PrivateRoutes path="/cadastros/concessionarias" exact component={Cadastros} />
        <PrivateRoutes path="/cadastros/grupos-dealer" exact component={Cadastros} />
        <PrivateRoutes path="/cadastros/concessionarias/nova" exact component={ConcessionariaNovoEditar} />
        <PrivateRoutes path="/cadastros/concessionarias/editar/:id" exact component={ConcessionariaNovoEditar} />
        <PrivateRoutes path="/cadastros/concessionarias/visualizar/:id" exact component={ConcessionariaNovoEditar} />
        <PrivateRoutes path="/cadastros/grupos-dealer/novo" exact component={GrupoDealerNovoEditar} />
        <PrivateRoutes path="/cadastros/grupos-dealer/editar/:id" exact component={GrupoDealerNovoEditar} />
        <PrivateRoutes path="/cadastros/grupos-dealer/visualizar/:id" exact component={GrupoDealerNovoEditar} />
        <PrivateRoutes path="/home-banners" exact component={PageHome} />
        <PrivateRoutes path="/galeria-midia" exact component={PageGaleriaMidia} />
        <PrivateRoutes path="/galeria-midia/:compartilharpasta" exact component={PageGaleriaMidia} />
        <PrivateRoutes path="/perfil-usuario" exact component={PerfilUsuario} />
        <PrivateRoutes path="/configuracoes" exact component={Configuracoes} />
        <PrivateRoutes path="/dashboard" exact component={Dashboard} />
        <PrivateRoutes path="/dashboard/relatorio/:tipo" exact component={RelatorioAnaliseAcessos} />
        <PrivateRoutes path="/log" exact component={Log} />
        {/* Link público de download compartilhado: casa com QUALQUER caminho de dois
            segmentos, então precisa ser a última rota do Switch. Enquanto ficava no
            topo, ela engolia /cadastros/concessionarias, /cadastros/grupos-dealer e
            /galeria-midia/:compartilharpasta. */}
        <Route path="/:idUsuario/:idLink" exact component={CompartilhadoDownload} />
      </Switch>
    </BrowserRouter>
  );
}